import React, { useEffect } from "react";
import { Box } from "@chakra-ui/react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { useDispatch, useSelector } from "react-redux";
import { getWishfyFrames } from "../../../../Redux/App/action";
import ProductCard from "../../../UI/ProductCard";

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 5,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 4,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

const FramesCrousel = () => {
  const dispatch = useDispatch();
  const { wishfyFrames } = useSelector((store) => store.appReducer);
  useEffect(() => {
    dispatch(getWishfyFrames);
  }, [dispatch]);

  return (
    <Box w="100%" mt={"2%"}>
      <Carousel responsive={responsive}>
        {wishfyFrames &&
          wishfyFrames.map((product, i) => (
            <ProductCard
              key={i}
              title={product.keyWords}
              productId={product.productId}
              productName={product.productName}
              productImage={product.img}
              price={product.priceDetails.price}
              sellingPrice={product.priceDetails.sellingPrice}
              discountPercentage={product.priceDetails.discountPercentage}
              quantityAvailable={product.isAllVariantSoldOut}
              variantId={product?.variants?.[0]?.id}
            />
          ))}
      </Carousel>
    </Box>
  );
};

export default FramesCrousel;
